import React from 'react'
import PropTypes from 'prop-types'
import {Route, Redirect} from 'react-router-dom'
import {isLoggedIn, setPersistentValue} from 'utils/session'

const PrivateRoute = ({ component: Component, children, ...rest }) => {
  if (!isLoggedIn()) {
    setPersistentValue('redirect', rest.location.pathname)
  }
  
  if (Component) {
    return (
      <Route
        {...rest} render={props => (isLoggedIn() ?
          (<Component {...props} />) : (<Redirect to={{pathname: '/login', state: { from: props.location }}} />))}
      />
    )
  }
  return (
    <Route {...rest}>
      {isLoggedIn() ?
        (React.cloneElement(children, {...rest})) : (<Redirect to={{pathname: '/login'}} />)}
    </Route>
  )
}

PrivateRoute.propTypes = {
  children: PropTypes.node,
  component: PropTypes.any,
  location: PropTypes.object,
}

export default PrivateRoute



// WEBPACK FOOTER //
// ./src/containers/PrivateRoute.js